import * as React from 'react';

const doNothing = (): void => { /* do nothing */ };

const stopEvent = (e?: Event | React.SyntheticEvent): void => {
  if (e) {
    e.stopPropagation();
    e.preventDefault();
  }
};


export const ConstantFunctions = {
  doNothing,
  stopEvent,
};
